module.exports = __webpack_public_path__ + "static/media/create-image.f6b80e06.svg";